import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import Logo from 'src/components/logo';
import { NavSectionMini } from 'src/components/nav-section';
import { hideScroll } from 'src/theme/css';
import { paths } from 'src/routes/paths';

import { useWhitelabelStore } from 'src/store/whitelabel/whitelabel.store';
import NavToggleButton from '../common/nav-toggle-button';
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';

// ----------------------------------------------------------------------

export default function NavMini() {
  const navData = useNavData();

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo 
          url={paths.dashboard.home.root}
          customLogo={useWhitelabelStore.getState().whitelabel?.logo ?? '/logo/logo-nectar-laranja.png'} 
          sx={{ mx: 'auto', my: 1 }} 
        />

        <NavSectionMini data={navData} />
      </Stack>
    </Box>
  );
}
